export const returnProtectionProductSku = 'FREERETURNS'
